import * as React from "react";
import { ChildProps, graphql } from "react-apollo";
import gql from "graphql-tag";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import {
  columnConfigFactory,
  GqlWithdrawalRequest,
} from "./withdrawalRequestsColumns";
import { RouteComponentProps, withRouter } from "react-router";

const PAGE_LIMIT = 20;

type GqlQueryResult = {
  withdrawal_batches: Array<{
    withdrawal_requests: Array<GqlWithdrawalRequest>;
  }>;
};

type Props = ChildProps<
  {
    name: string;
  } & BOComponentProps &
    RouteComponentProps<{ id: string }> &
    PaginationProps,
  GqlQueryResult
>;

class BatchWithdrawalRequestsContainer extends React.Component<Props> {
  onSubmit() {
    this.props.data.refetch();
  }

  render() {
    const withdrawals = this.props.data.withdrawal_batches?.length
      ? this.props.data.withdrawal_batches[0].withdrawal_requests
      : [];

    return (
      <BOGraphQLLoader data={this.props.data}>
        <ConfigurableTable
          name={this.props.name}
          pagination={this.props.pagination}
          columnConfigs={columnConfigFactory(this.onSubmit.bind(this))}
          defaultColumns={[
            "Created At",
            "Payable Amount",
            "Status",
            "Batch",
            "Fraud Status",
            "Action",
          ]}
          rows={withdrawals}
          rowToLink={(withdrawal: GqlWithdrawalRequest) =>
            `/snapscan/wallet_withdrawals/${withdrawal.reference}/summary`
          }
          history={this.props.history}
        />
      </BOGraphQLLoader>
    );
  }
}

/*
withdrawal_batches(id: $batchId) {
  id
  status
  archive_url
  comment
  ...

Although the above query fields are not used in this component, 
we have to include them here due to apollo's inability to merge state appropriately.

https://github.com/apollographql/apollo-client/issues/1611
*/
const withdrawalListGql = gql`
  query BatchWalletWithdrawalRequests(
    $batchId: ID!
    $offset: Int
    $limit: Int
  ) {
    withdrawal_batches(id: $batchId) {
      id
      status
      archive_url
      comment
      withdrawal_requests(offset: $offset, limit: $limit) {
        created_at
        reference
        status
        user {
          external_reference
          email
          snapmin_url
          devices {
            external_reference
            updated_at
            device_only_fraud_status
            token
            suspicious_token_status
            suspicious_token_comments {
              comment
              status
              updated_at
              user
            }
            phone_number
            suspicious_phone_number_status
            suspicious_phone_number_comments {
              comment
              status
              updated_at
              user
            }
          }
        }
        payable_amount
        withdrawal_batch {
          id
          status
        }
      }
    }
  }
`;

const withWithdrawalsGqlData = graphql<GqlQueryResult, Props>(
  withdrawalListGql,
  {
    options: (props) => {
      const {
        pagination: { offset, limit },
      } = props;

      return {
        fetchPolicy: "network-only",
        variables: {
          batchId: props.match.params.id,
          offset,
          limit,
        },
      };
    },
  }
);

export default withPagination(
  withRouter(withWithdrawalsGqlData(BatchWithdrawalRequestsContainer)),
  PAGE_LIMIT
);
